<template>
	<div class=" animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1" @click="link('/userHome')">当前位置：账户总览</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">最新系统消息</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回首页</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 消息列表 -->
		<div class="newsList">
			<div class="newsTit f-bct">
				<div class="txt f-ct">
					<el-image :src="require('@/static/icon53.png')"></el-image>
					<div class="t2">最新系统消息</div>
				</div>
				<div class="anniu f-ct">
					<div class="t1" @click="ReadAll">全部标记为已读</div>
					<div class="t2" @click="DeleteAll">清空</div>
				</div>
			</div>
			<div class="newsListBox">
				<div class="zw" v-if="!messageArr.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="newsItm" @click="messageRead(item)" v-for="(item,index) in messageArr">
					<div class="newTit f-bct">
						<div class="l f-ct">
							<p class="bor" v-if="!item.lookStatus"></p>
							<span>{{item.message.title}}</span>
						</div>
						<div class="r">{{gsTime(item.createTime)}}</div>
					</div>
					<div class="newTxt">
						{{item.message.content}}
					</div>
				</div>
				<!-- 分页 -->
				<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
				</div>	
				<!-- <div class="fenye">
					<el-image class="i1" :src="require('@/static/icon24.png')"></el-image>
					<div class="fyitm a">1</div>
					<div class="fyitm">2</div>
					<div class="fyitm">...</div>
					<div class="fyitm">3</div>
					<el-image class="i2" :src="require('@/static/icon25.png')"></el-image>
					<div class="linkPage f-ct">
						<p>跳转</p>
						<div class="ipt">
							<el-input type="text" v-model="mobile"></el-input>
						</div>
						<p>至</p>
					</div>
				</div> -->
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { messagememberMessageList,
messagecompanyMessageList,
messagememberReadAll,
messagecompanyReadAll,
messagememberDeleteAll,
messagecompanyDeleteAll,
messagecompanyRead,
messagememberRead,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 消息列表
			messageArr:[],
		}
	},
	mounted() {
		this.messageListGet(1)
	},
	methods:{
		// 阅读消息
		async messageRead(item,index){
			let res;
			if(this.userType==1){
				var data = {messageMemberId:item.id}
				res = await messagememberRead(data);
			}
			if(this.userType==2){
				var data = {messageCompanyId:item.id}
				res = await messagecompanyRead(data);
			}
			if(res.code==200){
				item.lookStatus = 1
				this.$set(this.messageArr,index,item)
			}else{this.Tips(res.msg,'error')}
		},
		// 刷新
		shuaxin(){
			this.Tips('操作成功','success')
			this.messageListGet(1)
		},
		// 全部删除
		async DeleteAll(def){
			let res;
			var data = {}
			// 学员
			if(this.userType==1){
				res = await messagememberDeleteAll(data);
			}
			// 企业
			if(this.userType==2){
				res = await messagecompanyDeleteAll(data);
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.messageListGet(1)
			}else{this.Tips(res.msg,'error')}
		},
		// 全部已读 
		async ReadAll(def){
			let res;
			var data = {}
			// 学员
			if(this.userType==1){
				res = await messagememberReadAll(data);
			}
			// 企业
			if(this.userType==2){
				res = await messagecompanyReadAll(data);
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.messageListGet(1)
			}else{this.Tips(res.msg,'error')}
		},
		// 查询消息列表
		async messageListGet(def){
			if(def){
				this.pageNum = 1
			}
			let res;
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			// 学员
			if(this.userType==1){
				res = await messagememberMessageList(data);
			}
			// 企业
			if(this.userType==2){
				res = await messagecompanyMessageList(data);
			}
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				res.rows.forEach((item)=>{
					item.message.content = item.message.content.replace(/<.*?>/g,"")
				})
				this.messageArr = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.messageListGet()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
			cursor: pointer;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.newsList{
	margin: 0 40px;
	background: #fff;
	border-radius: 0 0 20px 20px;
	.newsTit{
		height: 84px;
		border-radius: 20px 20px 0 0;
		background: #3B6492;
		padding-left: 24px;
		padding-right: 30px;
		.txt{
			.el-image{
				width: 40px;
				height: 40px;
				margin-right: 12px;
			}
			.t2{
				font-size: 18px;
				font-weight: bold;
				color: #fff;
			}
		}
		.anniu{
			div{
				border-radius: 8px;
				padding: 0 15px;
				height: 36px;
				line-height: 36px;
				background: #fff;
				margin-left: 12px;
				font-size: 14px;
				cursor: pointer;
			}
			.t1{
				color: #3B6492;
			}
			.t2{
				color: #FF5F5A;
			}
		}
	}
	.newsListBox{
		margin: 0 24px;
	}
	.newsItm{
		// height: 100px;
		border-bottom: 1px solid #DDDDDD;
		padding: 20px 0;
		.newTit{
			.l{
				.bor{
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin-right: 8px;
					background: #F26161;
				}
				span{
					font-size: 18px;
					// color: #333333;
				}
			}
			.r{
				font-size: 16px;
				color: #999999;
			}
		}
		.newTxt{
			color: #666666;
			font-size: 16px;
			margin-top: 14px;
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-bottom: 28px;
	margin-top: 30px;
	.i1{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	.fyitm{
		width: 32px;
		height: 32px;
		font-size: 12px;
		text-align: center;
		line-height: 32px;
		margin-right: 6px;
		border-radius: 4px;
	}
	.a{
		background: #3B6492;
		color: #fff;
	}
	.i2{
		width: 24px;
		height: 24px;
		margin-right: 19px;
	}
	.linkPage{
		p{
			font-size: 12px;
		}
		.ipt{
			margin: 0 6px;
			width: 42px;
			height: 32px;
			border-radius: 4px;
			background: #F4F4F4;
			.el-select{
				width: 100%;
			}
			::v-deep .el-input__inner{
				border: none;
				background: transparent;
			}
		}
	}
}
</style>